import React, { Component } from "react";
import _ from "lodash";
import classNames from "classnames";

class Breadcrumb extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  static getDerivedStateFromProps(props, state) {
    return null;
  }

  componentDidMount = () => {
  }

  componentDidUpdate(_, prevState) {
    
  }

  componentWillUnmount() {
  }

  render() {
    const { title, isFinished, isInProgress } = this.props;

    const classes = classNames({
      "onboarding-breadcrumb-item": true,
      "onboarding-breadcrumb-item-active": isInProgress,
      "onboarding-breadcrumb-item-complete": isFinished && !isInProgress,
    });

    return (
    <p className={classes} >{isFinished &&
        (<span className="onboarding-breadcrumb-check">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8.5" cy="8.5" r="8.5" fill="#00D193"/>
            <path d="M11.087 6.65222L7.52993 10.5327L5.91309 8.76882" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </span>)
    } {title}
    </p>
    );
  }

}

export default Breadcrumb;
